import { throttle } from 'throttle-debounce';

export const ctaViolator = {
    setupCtaViolator: () => {
        let violators = document.querySelectorAll('.js-violatorNegativeMargin');

        let setHeights = () => {
            violators.forEach((violator) => {
                let closestSection = violator.closest('section:not(.block--newctaviolatorblock)');
                let closestContainer = violator.closest('.block--newcontainerblock');
                let height = violator.offsetHeight;
                let calculatedMargin = (height / 2) * -1;
                let topMargin = calculatedMargin + 'px';
                let bottomMargin = calculatedMargin + 'px';

                violator.style.marginTop = topMargin;
                violator.style.marginBottom = bottomMargin;
                if(closestSection) {
                    closestSection.style.position = 'relative';
                    closestSection.style.zIndex = '3';
                } else if(closestContainer) {
                    closestContainer.style.position = 'relative';
                    closestContainer.style.zIndex = '3';
                }

            });
        };

        let removeHeights = () => {
            violators.forEach((violator) => {
                violator.removeAttribute('style');
            });
        }


        if (window.matchMedia('(min-width: 1024px)').matches) {
            setHeights();
        }

        window.addEventListener(
            'resize',
            throttle(1000, () => {
                if (window.matchMedia('(min-width: 1024px)').matches) {
                    setHeights();
                } else {
                    removeHeights();
                }
            })
        );
    },

    init: () => {
        ctaViolator.setupCtaViolator();
    },
};

document.addEventListener('DOMContentLoaded', () => {
    ctaViolator.init();
});
